import axios from 'axios';
import {
	ENDPOINT_URL,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_MSG,
	TOKEN_FAILED,
	APRECOMM_NOTIFICATION_URL,
	GET_GROUP_CONFIGURATION_API,
} from '../constants/commonConstants';
import { siteListQuery } from '../actions/graphAction/aprecomSiteList';
import { logout } from './userActions';
import { decryptData } from '../utils/crypto';
import aprecomAxios from '../utils/aprecomApiInterceptor';

/**
 * Need to notify aprecom when ap is moving from one site to another
 * @param {*} destSite
 * @param {*} payload
 * @param {*} doesSiteHaveAp
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const moveApAprecomApi =
	(destSite, payload, doesSiteHaveAp) =>
	async (dispatch) => {
		try {
			const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
			if (APPRECOM_BASE_URL) {
				if (doesSiteHaveAp) {
					const aprecomBody = {
						type: 'updateRouter',
						serialList: [
							{
								serialNumber:
									payload.apSerialNums[0].apSerialNum,
							},
						],
						siteName: destSite?.nested_site_name,
					};

					const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
					const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomBody));
					console.log('MOVE data DIRECT MOVE --- ', data);
					return data;
				} else {
					const APPRECOM_USER =
						decryptData(localStorage.getItem('apreTenantName'));
					const aprecomAddSiteBody = {
						type: 'addSite',
						custName: APPRECOM_USER,
						siteName: destSite?.nested_site_name,
						country: 'India',
						state: 'Karnataka',
						city: 'Banglore',
						lat: '34',
						long: '36',
					};

					const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
					const { data: aprecomAddSiteData } = await aprecomAxios.post(url,
						JSON.stringify(aprecomAddSiteBody)
					);
					console.log('MOVE data ADD SITE--- ', aprecomAddSiteData);
					const aprecomMoveApBody = {
						type: 'updateRouter',
						serialList: [
							{
								serialNumber:
									payload.apSerialNums[0].apSerialNum,
							},
						],
						siteName: destSite?.nested_site_name,
					};
					const { data: aprecomUpdateSiteData } = await aprecomAxios.post(url,
						JSON.stringify(aprecomMoveApBody)
					);
					console.log('MOVE data MOVE', aprecomUpdateSiteData);
					return aprecomUpdateSiteData;
				}
			} else {
				return 'APRECOM_URL_TOKNE_NOT_FOUND';
			}
		} catch (error) {
			console.log('moving aprecom error', error);
			return null;
		}
	};

/**
 * Need to notify aprecom when site is created
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyAddToAprecom = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));

		if (APPRECOM_BASE_URL) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'addSite',
				custName: APPRECOM_USER,
				siteName: payload?.nested_site_name,
				country: payload?.country || 'India',
				state: 'Karnataka',
				city: 'Banglore',
				lat: '34',
				long: '36',
			};
			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data: aprecomAddSiteData } = await aprecomAxios.post(url,
				JSON.stringify(aprecomAddSiteBody)
			);
			console.log('aprecomAddSiteData', aprecomAddSiteData);
			if (aprecomAddSiteData === 'Site Added Successfully') {
				dispatch(siteListQuery());
			}
			return aprecomAddSiteData;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('add notification aprecom error', error);
		return 'ERROR';
	}
};

/**
 * Need to notify aprecom when site is deleted
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyDeleteToAprecom = (payload) => async (dispatch) => {
	console.log('aprecomAddSiteData', payload);
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		if (APPRECOM_BASE_URL && payload) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'delSite',
				custName: APPRECOM_USER,
				...payload,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomAddSiteBody));
			console.log('aprecomAddSiteData', data);
			if (data === 'Site Deleted successfully') {
				dispatch(siteListQuery());
			}
			return data;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('delete notification aprecom error', error);
		return 'ERROR';
	}
};

/**
 * Need to notify aprecom when site is updated
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyUpdateToAprecom = (payload) => async (dispatch) => {
	console.log('aprecomAddSiteData', payload);
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		if (APPRECOM_BASE_URL) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'updateSite',
				custName: APPRECOM_USER,
				...payload,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url,  JSON.stringify(aprecomAddSiteBody));
			console.log('aprecomAddSiteData', data);
			if (data) {
				dispatch(siteListQuery());
			}
			return data;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('update notification aprecom error', error);
		return 'ERROR';
	}
};

/**
 * Need to notify aprecom when ap is updated
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyUpdateRouterToAprecom = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		if (APPRECOM_BASE_URL && payload) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'addRouter',
				custName: APPRECOM_USER,
				...payload,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomAddSiteBody));
			console.log('aprecomAddSiteData', data);
			return data;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('update router notification aprecom error', error);
		return 'ERROR';
	}
};

/**
 * Need to notify aprecom when ap is updated
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyRouterToAprecom = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		if (APPRECOM_BASE_URL && payload) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'updateRouter',
				custName: APPRECOM_USER,
				...payload,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomAddSiteBody));
			console.log('aprecomAddSiteData', data);
			return data;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('update router notification aprecom error', error);
		return 'ERROR';
	}
};

/**
 * Need to notify aprecom when ap is deleted
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyDeleteRouterToAprecom = (payload) => async (dispatch) => {
	console.log('aprecomAddSiteData', payload);
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		let routerList = [];
		if (payload?.serial_no?.length > 0) {
			routerList = payload?.serial_no?.map((obj) => {
				return { serialNumber: obj };
			});
		}

		if (APPRECOM_BASE_URL && routerList.length > 0) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddSiteBody = {
				type: 'delRouter',
				custName: APPRECOM_USER,
				routerList: routerList,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomAddSiteBody));
			console.log('aprecomAddSiteData', data);
			return data;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND OR ROUTERLIST NOT FOUND';
		}
	} catch (error) {
		console.log('delete router notification aprecom error', error);
		return 'ERROR';
	}
};

export const getGroupCongigAndUpdateAprecom =
	({ oldNestedSiteName, siteId }) =>
	async (dispatch, getState) => {
		try {
			const {
				userLogin: { userInfo },
			} = getState();

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: ENDPOINT_URL + GET_GROUP_CONFIGURATION_API + siteId + '/',
				headers: {
					'X-Encrypt': 'true',
					'Content-Type': 'application/json',
					Authorization: `${userInfo?.authorizationToken ?? ''}`,
				},
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('data--->', data);
			if (
				data &&
				data.status &&
				data.status === AUTH_TOKEN_ERROR_STATUS_CODE &&
				data.error &&
				data.error === AUTH_TOKEN_ERROR_STATUS_MSG
			) {
				dispatch(logout());
			} else if (data && data.data) {
				dispatch(
					notifyUpdateToAprecom({
						siteName: oldNestedSiteName,
						newName: data.data?.nested_site_name,
					})
				);
			}
		} catch (error) {
			const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			console.log('error ', error);
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
		}
	};

export const notifyAddUserToAprecom = (payload) => async (dispatch) => {
	console.log('aprecomAddSiteData', payload);
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		if (APPRECOM_BASE_URL) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			const aprecomAddUserBody = {
				type: 'addUser',
				username: payload.userName,
				tenant_name: APPRECOM_USER,
			};

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomAddUserBody));
			console.log('aprecomAddSiteData', data);
			return data;
		} else {
			return 'ERROR IN ADDING USER TO APRECOM';
		}
	} catch (error) {
		console.log('ERROR IN ADDING USER TO APRECOM', error);
		return 'ERROR';
	}
};

export const notifyDeleteUserToAprecom = (payload) => async (dispatch) => {
	console.log('aprecomAddSiteData', payload);
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));

		if (APPRECOM_BASE_URL) {
			const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
			payload?.forEach(async (user) => {
				const aprecomDeleteUserBody = {
					type: 'delUser',
					username: user.username,
					tenant_name: APPRECOM_USER,
				};

				const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
				const { data } = await aprecomAxios.post(url, JSON.stringify(aprecomDeleteUserBody));
				console.log('aprecomAddSiteData', data);
				return data;
			});
		} else {
			return 'ERROR IN DELETING USER TO APRECOM';
		}
	} catch (error) {
		console.log('ERROR IN DELETING USER TO APRECOM', error);
		return 'ERROR';
	}
};

/**
 * Need to notify bulk add site to aprecom
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyBulkAddSiteToAprecomApi = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
		if (APPRECOM_BASE_URL && APPRECOM_USER && Array.isArray(payload) && payload.length > 0) {
			const apprecomPayload = {
				"type": "addSite",
				siteList : []
			};
			apprecomPayload.siteList = payload?.map((obj) => {
				return { 
					siteName: reverseAndFormat(obj.siteName)					,
					custName : APPRECOM_USER,
					"country": "India",
					"state": "karnataka",
					"city": "Bangalore",
					"lat": '34',
					"long": '36'
				};
			});
			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data: aprecomAddSiteData } = await aprecomAxios.post(url,
				JSON.stringify(apprecomPayload)
			);
			console.log('aprecomAddSiteData', aprecomAddSiteData);
			if (aprecomAddSiteData === 'Site Added Successfully') {
				dispatch(siteListQuery());
			}
			return aprecomAddSiteData;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('add notification aprecom error', error);
		return 'ERROR';
	}
};

const reverseAndFormat = (input) => {
	console.log("input", input)
    return input.includes(",") ? input.split(",").reverse().join(" | ") : input;
};

/**
 * Need to notify bulk add router to aprecom
 * @param {*} payload
 * @return {function} - Asynchronous function that dispatches actions based on the API response
 */
export const notifyBulkAddRouterToAprecomApi = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		const APPRECOM_TOKEN = decryptData(localStorage.getItem('aprecom_token'));
		const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
		console.log("bulkAddAP", payload)
		if (APPRECOM_BASE_URL && APPRECOM_USER && APPRECOM_TOKEN && Array.isArray(payload) && payload.length > 0) {
			const params = new URLSearchParams();
			params.append('type', 'addRouter');
			payload?.forEach((router,index) => {
				params.append(`routerList[${index}][serialNumber]`, router.apSerialNum);
				params.append(`routerList[${index}][siteName]`, reverseAndFormat(router.siteName));
				params.append(`routerList[${index}][routerName]`, router.apName);
				params.append(`routerList[${index}][custName]`, APPRECOM_USER);
			});
			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const aprecomAddRouterConfig = {
				method:"post",
				maxBodyLength: Infinity,
				url: url,
				headers: {
					'X-Encrypt': 'true',
					'Content-Type': 'application/x-www-form-urlencoded',
					Authorization: APPRECOM_TOKEN,
				},
				data: params,
			};
			const { data: aprecomAddRouterData } = await axios.request(aprecomAddRouterConfig);
			console.log('aprecomAddRouterData', aprecomAddRouterData);
			return aprecomAddRouterData;
		} else {
			return 'APRECOM_URL_TOKNE_NOT_FOUND';
		}
	} catch (error) {
		console.log('add notification aprecom error', error);
		return 'ERROR';
	}
};


export const notifyAddTenantToAprecom = (payload) => async (dispatch) => {
    try {
        const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
        console.log("notifyAddTenantToAprecom", payload)
        if (APPRECOM_BASE_URL) {
            const aprecomAddTenantBody = {
                type: 'addTenantSuperUser',
                username: payload?.tenant_username,
				tenant_name: payload?.tenant,
				cnmsUrl: `https://${payload?.domain_url}`
            };
            const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
            const { data: aprecomAddTenantData } = await aprecomAxios.post(url, JSON.stringify(aprecomAddTenantBody));
            console.log("aprecomAddTenantData", aprecomAddTenantData)
            return aprecomAddTenantData
        }else {
            return "APRECOM_URL_TOKNE_NOT_FOUND"
        }
    } catch (error) {
       console.log("add notification aprecom error", error)
       return "ERROR"
    }
};

export const notifyCloneSiteToAprecom = (payload) => async (dispatch) => {
	try {
		const APPRECOM_BASE_URL = decryptData(localStorage.getItem('aprecom_url'));
		const APPRECOM_USER = decryptData(localStorage.getItem('apreTenantName'));
		if (APPRECOM_BASE_URL && APPRECOM_USER && Array.isArray(payload) && payload.length > 0) {
			const apprecomClonePayload = {
				"type": "addSite",
				siteList : []
			};
			apprecomClonePayload.siteList = payload?.map((obj) => {
				return { 
					siteName: obj.nested_site_name				,
					custName : APPRECOM_USER,
					"country": "India",
					"state": "karnataka",
					"city": "Bangalore",
					"lat": '34',
					"long": '36'
				};
			});

			const url = APPRECOM_BASE_URL + APRECOMM_NOTIFICATION_URL;
			const { data } = await aprecomAxios.post(url, JSON.stringify(apprecomClonePayload));
			return data;
		} else {
			return 'ERROR IN CLONING SITE TO APRECOM';
		}
	} catch (error) {
		console.log('ERROR IN CLONING SITE TO APRECOM', error);
		return 'ERROR';
	}
};